import React from "react";
import usePermission from "../../utils/usePermission";
import UnAuthorized from "../UnAuthorized/UnAuthorized";
import { Accordion } from "react-bootstrap";
import { CiSearch } from "react-icons/ci";
import { FaEye } from "react-icons/fa";
import useRoleListing from "../../customHooks/RoleListing/useRoleListing";
import { MdEdit } from "react-icons/md";
import { useNavigate } from "react-router";
import FullPageLoading from "../../components/FullPageLoading/FullPageLoading";
import Pagination from "react-js-pagination";

const RoleListing = () => {
  const {
    handlePageClick,
    handlePageSizeChange,
    handleSearch,
    roles,
    totalCount,
    searchTerm,
    rolesPerPage,
    loader,
    currentPage,
  } = useRoleListing();
  const navigate = useNavigate();
  const canRead = usePermission("ROLE_READ");
  const canCreate = usePermission("ROLE_CREATE");
  const canUpdate = usePermission("ROLE_UPDATE");

  return (
    <div>
      {canRead ? (
        <div className="container">
          <div className="mainHeader">
            <h1 className="font-semibold text-lg">Roles</h1>
            {canCreate && (
              <button
                className="add-plan-button"
                onClick={() => {
                  navigate("/role/create");
                }}
              >
                + Add New Role
              </button>
            )}
          </div>
          <div className="mainHeader">
            <div className="search-container">
              <input
                type="text"
                placeholder="Search..."
                className="search-input"
                value={searchTerm}
                onChange={handleSearch}
              />

              <CiSearch className="search-icon" />
            </div>
            <div className="items-per-page-container">
              <select
                id="itemsPerPage"
                value={rolesPerPage}
                onChange={handlePageSizeChange}
                className="items-per-page-dropdown"
              >
                <option value={5}>5</option>
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option val40pxue={50}>50</option>
              </select>
            </div>
          </div>
          {!loader ? (
            <>
              <div className="mainContainer">
                <div className="table-container">
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th>Role Name</th>
                        <th>Role Description</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {roles.length > 0 ? (
                        <>
                          {roles.map((row, index) => (
                            <tr key={index}>
                              <td>{row.name || "-"}</td>
                              <td>{row.description || "-"}</td>
                              <td className="actionBtns">
                                {canUpdate && (
                                  <button
                                    className="editButton"
                                    onClick={() => navigate(`/role/${row.id}`)}
                                  >
                                    <MdEdit />
                                  </button>
                                )}
                                {/* 
          <button
            className="editButton"
            style={{ background: "" }}
            onClick={() => navigate(`/role/${row.id}`)}
          >
            <FaEye />
          </button> 
          */}
                              </td>
                            </tr>
                          ))}
                        </>
                      ) : (
                        <tr>
                          <td colSpan={3} className="text-center">
                            {" "}
                            No Roles Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="mt-6 flex justify-between items-center">
                <span className="text-gray-600">
                  Showing {(currentPage - 1) * rolesPerPage + 1} to{" "}
                  {Math.min(currentPage * rolesPerPage, totalCount)} of{" "}
                  {totalCount} entries
                </span>
                {totalCount > rolesPerPage && (
                  <Pagination
                    activePage={currentPage}
                    itemsCountPerPage={rolesPerPage}
                    totalItemsCount={totalCount}
                    pageRangeDisplayed={5}
                    onChange={handlePageClick}
                    nextPageText={">"}
                    prevPageText={"<"}
                    firstPageText={"<<"}
                    lastPageText={">>"}
                    itemClass="page-item"
                    linkClass="page-link"
                  />
                )}
              </div>
            </>
          ) : (
            <>
              <FullPageLoading />
            </>
          )}
        </div>
      ) : (
        <UnAuthorized />
      )}
    </div>
  );
};

export default RoleListing;
